import { jsx as _jsx } from "react/jsx-runtime";
import { chakra, forwardRef } from '@chakra-ui/react';
export const Svg = forwardRef((props, ref)=>/*#__PURE__*/ _jsx(chakra.svg, {
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        ref: ref,
        ...props
    })
);
